import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Dashboard from './components/views/admin/Dashboard';
// import KnowledgeBase from "./components/views/admin/KnowledgeBase";
import DashboardCardExpanded from './components/views/admin/DashboardCardExpanded';
import DashboardCardViews from './components/views/admin/DashboardCardViews';

import Main from './components/layouts/Main';
import MainAdmin from './components/layouts/MainAdmin';
import MainLogin from './components/layouts/MainLogin';

import Login from './components/views/login/Login';
import Forgot from './components/views/login/Forgot';
import Reset from './components/views/login/Reset';
import SecondAuth from './components/views/login/SecondAuth';

class Routing extends Component {
	render() {
		return (
			<Router>
				<Routes>
					<Route path="/" element={<Main />} />
					<Route path="/dashboard" element={<MainAdmin />}>
						<Route path="/dashboard" element={<Dashboard />} />
						<Route
							path="/dashboard/:card"
							element={<DashboardCardExpanded />}
						/>
						<Route
							path="/dashboard/:card/:views/:id"
							element={<DashboardCardViews />}
						/>
						<Route
							path="/dashboard/:card/:views"
							element={<DashboardCardViews />}
						/>
					</Route>
					<Route element={<MainLogin />}>
						<Route path="/login" element={<Login />} />
						<Route path="/recovery" element={<Forgot />} />
						<Route path="/change-password/:hash" element={<Reset />} />
						<Route path="/2fa" element={<SecondAuth />} />
						<Route path="/2fa/:code/:interimToken" element={<SecondAuth />} />
					</Route>
				</Routes>
			</Router>
		);
	}
}

export default Routing;
